module.exports = __webpack_public_path__ + "static/media/checklist.4d934863.svg";